var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-zone',{staticClass:"split-bottom"}),_c('second-zone'),_c('choice-comp-zone'),_c('value-added-zone'),_c('new-job-zone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }